import debounce from 'lodash/debounce';

class ContactBar {
  constructor() {
    this.settings = {
      contactBar: '.js-contact-bar',
      activeClass: 'active',
      ajaxAction: 'updateContactCounter',
    };
  }

  init() {
    const $contactBar = $(this.settings.contactBar);
    const $this = this;
    this.handleScroll = debounce(this.handleScroll.bind(this), 10);
    window.addEventListener('scroll', this.handleScroll);
    $contactBar.on({
      click() {
        $this.updateCounter(this);
      },
    });
  }

  updateCounter(item) {
    const itemClasses = $(item).attr('class');
    $.ajax({
      url: '/wp-admin/admin-ajax.php',
      type: 'POST',
      dataType: 'json',
      data: {
        class: itemClasses,
        action: this.settings.ajaxAction,
      },
      success(response) {
        console.log(response);
      },
    });
  }

  handleScroll() {
    const doc = document.documentElement;
    const $contactBar = $(this.settings.contactBar);
    const position = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    if (position > window.innerHeight / 2
      && !$contactBar.hasClass(this.settings.activeClass)
      && position <= doc.offsetHeight - doc.clientHeight - 200) {
      $contactBar.addClass(this.settings.activeClass);
    } else if ($contactBar.hasClass(this.settings.activeClass)
      && position <= window.innerHeight / 2) {
      $contactBar.removeClass(this.settings.activeClass);
    } else if ($contactBar.hasClass(this.settings.activeClass)
      && position >= doc.offsetHeight - doc.clientHeight - 200) {
      $contactBar.removeClass(this.settings.activeClass);
    }
  }
}

export default ContactBar;
